import "./appinitandstate/TocAvailabilityNotice.css";
import "./App.css";
import { faHome, faWarning } from "@fortawesome/free-solid-svg-icons";
import { ContainerWithHeaderAndMenu } from "./menuandheader/ContainerWithHeaderAndMenu";
import { Link } from "react-router-dom";
import { RoutePaths } from "./RoutePaths";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";

export function InvalidRouteElement() {
  const { t } = useTranslation();

  return (
    <ContainerWithHeaderAndMenu
      icon={faWarning}
      title={t("items.edit.invalidPage")}
    >
      <p>{t("items.edit.invalidPageDesc")}</p>

      <Button tag={Link} to={RoutePaths.HOME} color="primary">
        <FontAwesomeIcon icon={faHome} /> {t("items.edit.backToHome")}
      </Button>
    </ContainerWithHeaderAndMenu>
  );
}
